// extracted by mini-css-extract-plugin
export default {"Virtual":"virtual_Virtual__nsbO+","left":"virtual_left__RUpmt","wrapper":"virtual_wrapper__WJMGO"};